/**
 * Pricing Config tab of the consolidated Admin → Pricing screen.
 *
 * The two admin-gated pricing tables from
 * frontend_documentation/pricing-config-and-lock-extensions.md §1–§2, served by
 * `/correspondents/admin/*`:
 *
 *   Tier margins  — the `dscr_tier_margins` collection. BOND POINTS (par = 100).
 *                   These drive the correspondent tier dropdown, so the tier list
 *                   here IS the enum; nothing is hardcoded.
 *   Rates by tier — `GET /admin/data/rtl-pricing/tier-rates`: each RTL
 *                   product's live 12-month base + each correspondent tier's
 *                   spread, with a 0.125% what-if stepper (PERCENT). Replaced
 *                   the legacy "Base rates by product and term" grid on
 *                   2026-10-09: that read the old `rtl_base_rates` store, which
 *                   is empty and is NOT what prices — the live base rates are on
 *                   RTL & GUC Pricing (admin-rtl-pricing-config.md).
 *
 * Both are version-history tracked server-side (who / when / old→new) and
 * publish to the `pricing_updates` Service Bus topic on save, so the per-row
 * history dialog is the audit surface for a rate change.
 *
 * These are the values the LOCK desk resolves against, which is why they live
 * apart from the RTL model tab: that tab configures how a rate is composed, this
 * one holds the correspondent-facing numbers a lock is written from.
 */
import Txt from "../../../components/typography/Txt";
import TierMarginsPanel from "./TierMarginsPanel";
import RtlTierRatesPanel from "./RtlTierRatesPanel";
import { FormulaBanner, PricingPageLayout, T } from "./pricingUi";

export const CONFIG_RAIL = [
  { id: "cfg-tier-margins", label: "DSCR tier margins" },
  { id: "cfg-tier-rates", label: "RTL & GUC rates by tier" },
];

const FORMULA = [
  { chip: "correspondent tier" },
  { op: "→" },
  { chip: "margin points" },
  { op: "·" },
  { chip: "price floor / ceiling" },
];

export default function PricingConfigPane() {
  return (
    <PricingPageLayout nav={CONFIG_RAIL}>
      <FormulaBanner
        lead="Lock inputs ="
        parts={FORMULA}
        tail="→ every save is audited and published to pricing_updates"
      />

      <TierMarginsPanel />
      <RtlTierRatesPanel />

      <Txt sx={{ fontSize: 11, color: T.faint, px: 0.5 }}>
        No pricing value is hardcoded. DSCR tier margins are bond points (par =
        100); RTL and GUC rates and tier spreads are annual percents (8.125 =
        8.125%). The two scales never mix in one field.
      </Txt>
    </PricingPageLayout>
  );
}

